/**
 * Utility for composing CSS Module class names.
 * Filters falsy values and joins truthy ones.
 *
 * @param {...(string|false|null|undefined)} classes - Class names or falsy values
 * @returns {string} Space-separated class string
 *
 * @example
 * // Simple conditional
 * cx(styles.btn, isActive && styles.btnActive)
 * // => "btn_x7d3k btnActive_j2m9p" (when isActive is true)
 * // => "btn_x7d3k" (when isActive is false)
 *
 * @example
 * // Multiple conditions
 * cx(
 *   styles.card,
 *   isFlipped && styles.cardFlipped,
 *   isMatched && styles.cardMatched,
 *   isDisabled && styles.cardDisabled
 * )
 */
export const cx = (...classes) => classes.filter(Boolean).join(' ')
